import * as React from 'react';
import { Paper, Typography } from "@mui/material";
import Zoom from '@mui/material/Zoom';

export const PopupViewPass = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)

    React.useEffect(() => {
        setTransitionIn(false)
        const key = setTimeout(() => {  
            setTransitionIn(true)
        }, 0);

        return () => clearTimeout(key)
    }, [item])

    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className='gisPopup' style={{width:'220px'}}>
                <div className='popTit' style={{ overflow: "hidden", whiteSpace: "nowrap", position: "relative" }}>
                    <div
                        style={{
                        display: "inline-block",
                        paddingLeft: "100%",
                        animation: "scroll-left 10s linear infinite",
                        }}
                    >
                        <span className='id'>{item.nm}</span>
                    </div>

                    {/* Keyframes injection */}
                    <style>
                        {`
                        @keyframes scroll-left {
                            0% { transform: translateX(0%); }
                            100% { transform: translateX(-100%); }
                        }
                        `}
                    </style>
                </div>
                <div className='popConts' style={{display: "grid", gridTemplateColumns: "0.3fr 0.7fr", gap: "12px", fontSize: "20px"}}>
                    <div className='subTxt'>승차</div>
                    <div className='gr subTxt'>{item.inCnt}</div>
                    <div className='subTxt'>하차</div>
                    <div className='subTxt'>{item.outCnt}</div>
                </div>
            </div>
        </Zoom>
    )
}